module.exports = __webpack_public_path__ + "static/img/043 5.3ff0d395.jpg";